const styles = theme => ({
  root: {
    padding: 0,
  },
  content: {
    width: 475,
    padding: 20,
    textAlign: 'center',
    fontSize: theme.constants.fontSizes.regular,
  },
});

export default styles;
